// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.student-inner-header {
  font-weight: 600;
  font-family: Rockwell, Verdana, Arial, sans-serif;
  color: #00375d;
  font-size: 16px;
  padding-left: 0.2em;
  margin-top: 0px;
  margin-bottom: 1em;
}

.student-list-image {
  width: 95%;
}

.cp-electives-outer {
  border: 1px solid #809baf;
  padding-top: 1.5em;
  padding-bottom: 15px;
  padding-left: 1.5%;
}

.cp-name {
  font-weight: 600;
  font-family: Verdana, Arial, sans-serif;
  font-size: 14px;
  margin-bottom: 5px;
}

.cp-description {
  font-size: 14px;
  margin-bottom: 10px;
}

.cp-summary {
  font-size: 12px;
}

.cp-show-list {
  text-align: center;
  margin-top: 5px;
  width: 95%;
}

.cp-show-list a {
  color: #00a1de;
  font-size: 12px;
  padding-right: 15px;
}

.cp-show-list a {
  color: #00a1de;
  font-size: 12px;
  padding-right: 15px;
  text-decoration: none;
}

.cp-show-list a:hover {
  text-decoration: underline;
}

#no-career-paths-msg {
  font-weight: 600;
  font-family: Verdana, Arial, sans-serif;
  color: #00375d;
  font-size: 14px;
  text-align: center;
  padding: 25px;
}

.cp-electives-outer .row {
  margin-left: 0px;
  margin-right: 0px;
  padding-bottom: 15px;
}

.cp-electives-outer hr {
  margin-left: 15px;
  margin-right: 15px;
  margin-top: 0px;
}

student-career-path-list .infoSection {
  margin-left: 10px;
  margin-bottom: 4px;
  color: black;
  font-size: 14px;
  list-style: none;
  padding-top: 2rem;
}

student-career-path-list .descriptionSection {
  padding-left: 0px;
  margin-left: 10px;
  margin-bottom: 10px;
  flex: 1;
}

student-career-path-list .infoSection.topLevel {
  font-size: 14px;
  padding-top: 2rem;
  padding-bottom: 2rem;
}

student-career-path-list .courseGroupContainer .mainImg {
  width: 100%;
}
student-career-path-list .courseGroupContainer .info {
  padding-left: 1rem;
}

student-career-path-list .courseGroupContainer .assignmentName {
  margin-top: 0px;
  margin-bottom: 0px;
  font-weight: bold;
  font-size: 14px;
}
student-career-path-list .courseGroupContainer h3 {
  margin: 0px 0px 15px;
}

student-career-path-list .courseGroupContainer.courseMeta {
  display: flex;
  flex-direction: row;
  font-size: 14px;
  padding-top: 0.1rem;
  flex-wrap: wrap;
}

student-career-path-list .courseGroupContainer .courseMetaContainer {
  margin-bottom: 4rem;
}

student-career-path-list .courseGroupContainer .imageDate {
  padding-left: 0px;
  padding-right: 0px;
}

student-career-path-list
  .courseGroupContainer
  .courseMeta
  span:nth-last-child(n + 2):after {
  content: '|';
  color: black;
  padding-right: 6px;
  margin-left: 1.5rem;
  margin-right: 0.9rem;
}

student-career-path-list .courseGroupContainer .title {
  margin-left: 15px;
  padding-left: 0px;
  width: 70%;
}

student-career-path-list .detailsTopContainer {
  width: 100%;
}

student-career-path-list .detailsTopContainer.topLevel {
  border: 1px solid #00375d;
}

student-career-path-list .courseGroupScroll {
  margin-left: 1%;
  width: 98%;
  flex: 1;
}

student-career-path-list .careerPathScroll {
  width: 100%;
  margin-top: 2rem;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/studentui/studentCareerPathList.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iDAAiD;EACjD,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,uCAAuC;EACvC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,uCAAuC;EACvC,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,OAAO;AACT;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;;EAIE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,UAAU;EACV,OAAO;AACT;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB","sourcesContent":[".student-inner-header {\n  font-weight: 600;\n  font-family: Rockwell, Verdana, Arial, sans-serif;\n  color: #00375d;\n  font-size: 16px;\n  padding-left: 0.2em;\n  margin-top: 0px;\n  margin-bottom: 1em;\n}\n\n.student-list-image {\n  width: 95%;\n}\n\n.cp-electives-outer {\n  border: 1px solid #809baf;\n  padding-top: 1.5em;\n  padding-bottom: 15px;\n  padding-left: 1.5%;\n}\n\n.cp-name {\n  font-weight: 600;\n  font-family: Verdana, Arial, sans-serif;\n  font-size: 14px;\n  margin-bottom: 5px;\n}\n\n.cp-description {\n  font-size: 14px;\n  margin-bottom: 10px;\n}\n\n.cp-summary {\n  font-size: 12px;\n}\n\n.cp-show-list {\n  text-align: center;\n  margin-top: 5px;\n  width: 95%;\n}\n\n.cp-show-list a {\n  color: #00a1de;\n  font-size: 12px;\n  padding-right: 15px;\n}\n\n.cp-show-list a {\n  color: #00a1de;\n  font-size: 12px;\n  padding-right: 15px;\n  text-decoration: none;\n}\n\n.cp-show-list a:hover {\n  text-decoration: underline;\n}\n\n#no-career-paths-msg {\n  font-weight: 600;\n  font-family: Verdana, Arial, sans-serif;\n  color: #00375d;\n  font-size: 14px;\n  text-align: center;\n  padding: 25px;\n}\n\n.cp-electives-outer .row {\n  margin-left: 0px;\n  margin-right: 0px;\n  padding-bottom: 15px;\n}\n\n.cp-electives-outer hr {\n  margin-left: 15px;\n  margin-right: 15px;\n  margin-top: 0px;\n}\n\nstudent-career-path-list .infoSection {\n  margin-left: 10px;\n  margin-bottom: 4px;\n  color: black;\n  font-size: 14px;\n  list-style: none;\n  padding-top: 2rem;\n}\n\nstudent-career-path-list .descriptionSection {\n  padding-left: 0px;\n  margin-left: 10px;\n  margin-bottom: 10px;\n  flex: 1;\n}\n\nstudent-career-path-list .infoSection.topLevel {\n  font-size: 14px;\n  padding-top: 2rem;\n  padding-bottom: 2rem;\n}\n\nstudent-career-path-list .courseGroupContainer .mainImg {\n  width: 100%;\n}\nstudent-career-path-list .courseGroupContainer .info {\n  padding-left: 1rem;\n}\n\nstudent-career-path-list .courseGroupContainer .assignmentName {\n  margin-top: 0px;\n  margin-bottom: 0px;\n  font-weight: bold;\n  font-size: 14px;\n}\nstudent-career-path-list .courseGroupContainer h3 {\n  margin: 0px 0px 15px;\n}\n\nstudent-career-path-list .courseGroupContainer.courseMeta {\n  display: flex;\n  flex-direction: row;\n  font-size: 14px;\n  padding-top: 0.1rem;\n  flex-wrap: wrap;\n}\n\nstudent-career-path-list .courseGroupContainer .courseMetaContainer {\n  margin-bottom: 4rem;\n}\n\nstudent-career-path-list .courseGroupContainer .imageDate {\n  padding-left: 0px;\n  padding-right: 0px;\n}\n\nstudent-career-path-list\n  .courseGroupContainer\n  .courseMeta\n  span:nth-last-child(n + 2):after {\n  content: '|';\n  color: black;\n  padding-right: 6px;\n  margin-left: 1.5rem;\n  margin-right: 0.9rem;\n}\n\nstudent-career-path-list .courseGroupContainer .title {\n  margin-left: 15px;\n  padding-left: 0px;\n  width: 70%;\n}\n\nstudent-career-path-list .detailsTopContainer {\n  width: 100%;\n}\n\nstudent-career-path-list .detailsTopContainer.topLevel {\n  border: 1px solid #00375d;\n}\n\nstudent-career-path-list .courseGroupScroll {\n  margin-left: 1%;\n  width: 98%;\n  flex: 1;\n}\n\nstudent-career-path-list .careerPathScroll {\n  width: 100%;\n  margin-top: 2rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
